module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Tous les avantages Beauty Insider',
        signIn: 'Ouvrir une session',
        signInSubText: 'pour voir vos points et profiter des récompenses.',
        applyText: 'Appliquer',
        noBiPoints: `Vous avez maintenant <b>${vars[0]}</b> points Beauty Insider.`,
        biPoints: `Vous avez actuellement <b>${vars[0]} points</b>`,
        cxsMissingMessage: 'Beauty Insider nʼest pas disponible pour le moment. Veuillez revenir plus tard.',
        exceededCheckoutPoints: `You are exceeding by ${vars[0]} points. Please remove the BI cash to continue to checkout.`,
        joinNow: 'Join now',
        joinNowSubText: 'to save your points and redeem rewards.'
    };

    return resources[label];
};
